import type { KeyPortMessage } from '../../../../types/KeyPortMessage';
import type { KeyPortRequestMessage } from '../../../../types/KeyPortRequestMessage';
import { ProductContext } from '../../../../types/ProductContext';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

export const createKeyPort = async (keyPort: KeyPortRequestMessage): Promise<KeyPortMessage> => {
    const response = await authorizedAxiosInstance.post('/v1/key-ports', {
        ...keyPort,
        context: ProductContext.LUBES,
    });

    return response.data;
};

export interface UpdateKeyPortParams {
    keyPortId: string;
    keyPort: KeyPortRequestMessage;
}
export const updateKeyPort = async ({ keyPort, keyPortId }: UpdateKeyPortParams): Promise<KeyPortMessage> => {
    const response = await authorizedAxiosInstance.put(`/v1/key-ports/${keyPortId}`, {
        ...keyPort,
        context: ProductContext.LUBES,
    });

    return response.data;
};
export const deleteKeyPort = async (keyPortId: string) => {
    const response = await authorizedAxiosInstance.delete(`/v1/key-ports/${keyPortId}`);

    return response.data;
};
export interface KeyPortListMessage {
    portId: string;
    vesselLimitations?: string[];
}

interface GetKeyPortListResponse {
    keyPorts: KeyPortListMessage[];
}

export const getKeyPortList = async (): Promise<GetKeyPortListResponse> => {
    const response = await authorizedAxiosInstance.get('/v1/key-ports/list', {
        params: { context: ProductContext.LUBES },
    });

    return response.data;
};
